import { parseApiError } from "src/api/errors";
import { buildApiUrl } from "src/api/client";

export interface SpbhlPlayerSearchItem {
  playerId: string;
  fullName: string;
  birthDate?: string | null;
  teamName?: string | null;
  jerseyNumber?: number | null;
  photoSmallUrl: string;
  photoLargeUrl: string;
  profileUrl: string;
}

export interface SpbhlPlayersSearchResponse {
  page: number;
  totalPages: number;
  players: SpbhlPlayerSearchItem[];
}

export interface SearchSpbhlPlayersParams {
  fullName: string;
  birthYear?: string;
  page?: number;
}

export async function searchSpbhlPlayers(
  params: SearchSpbhlPlayersParams,
): Promise<SpbhlPlayersSearchResponse> {
  const query = new URLSearchParams();
  query.set("fullName", params.fullName.trim());

  if (params.birthYear?.trim()) {
    query.set("birthYear", params.birthYear.trim());
  }

  query.set("page", String(params.page ?? 1));

  const res = await fetch(buildApiUrl(`/api/spbhl/players?${query.toString()}`));

  if (!res.ok) {
    throw await parseApiError(res, "Не удалось выполнить поиск по СПБХЛ");
  }

  return res.json();
}
